module.exports = __webpack_public_path__ + "guanao-pc/static/media/xiequan.7bcf432f.jpg";